/**
 * The signed contract's file name when the download's `Content-Disposition` cannot be read. The
 * service names the file the same way (`license-holder-declaration-{site}.pdf`). Saving the blob is
 * `saveBlob` in `creatives/download-asset.ts` (Decision 11).
 */

const site = (value: string | null | undefined): string =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

/** `license-holder-declaration-{site}.pdf`, site = domain (trimmed, lower-cased) else brand (trimmed,
 *  lower-cased) else 'brand'. */
export const fallbackFilename = (details: { domain?: string | null; brand?: string | null } | undefined): string =>
  `license-holder-declaration-${site(details?.domain) || site(details?.brand) || 'brand'}.pdf`;
